import { useState } from 'react'
import { FaAngleLeft } from 'react-icons/fa6'

const PaginatedList = ({
  data,
  renderCard,
  pageSize = 6,
  className = '',
  innerClassName = 'space-y-4'
}) => {
  const [currentPage, setCurrentPage] = useState(1)

  const startIndex = (currentPage - 1) * pageSize
  const endIndex = startIndex + pageSize
  const currentData = data?.slice(startIndex, endIndex)

  const handlePageChange = page => {
    setCurrentPage(page)
  }
  if (!data || data?.length === 0) {
    return
  }
  return (
    <div className={className}>
      <div className={`${innerClassName}`}>
        {currentData?.map((item, index) => renderCard(item, startIndex + index))}
      </div>
      {data && data.length > pageSize && (
        <div className='flex justify-center mt-4'>
          <nav>
            <ul className='flex space-x-2 list-none'>
              {/* show single left arrow and double left arrow buttons */}

              <li>
                <button
                  disabled={currentPage === 1}
                  onClick={() => handlePageChange(currentPage - 1)}
                  className='px-3 py-1 h-full rounded-md font-medium bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed'
                >
                  <FaAngleLeft />
                </button>
              </li>

              {/* show single right arrow and double right arrow buttons */}

              {Array.from(
                { length: Math.ceil(data?.length / pageSize) },
                (_, i) => (
                  <li key={i}>
                    <button
                      onClick={() => handlePageChange(i + 1)}
                      className={`px-3 py-1 rounded-md font-medium transition-all ${
                        currentPage === i + 1
                          ? 'bg-gray-900 text-white'
                          : 'bg-gray-200'
                      }`}
                    >
                      {i + 1}
                    </button>
                  </li>
                )
              )}
              <li>
                <button
                  disabled={currentPage === Math.ceil(data?.length / pageSize)}
                  onClick={() => handlePageChange(currentPage + 1)}
                  className='px-3 py-1 h-full rounded-md font-medium bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed'
                >
                  <FaAngleLeft className='rotate-180' />
                </button>
              </li>
            </ul>
          </nav>
        </div>
      )}
    </div>
  )
}

export default PaginatedList
